export default {
  SET_STORAGE_MATERIAL(state, data) {
    state.storageMaterial = data
  },

  SET_STORAGE_INSTRUMENT(state, data) {
    state.storageInstrument = data
  },
}
